import { useMemo } from 'react'

import { useScreen } from '@/store/screen'

export const useServicesSection = () => {
  const { windowSize } = useScreen()

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h4' as const,
        topicTitle: 'h5' as const,
        topicDescription: 'b3' as const,
      },
      791: {
        title: 'h5' as const,
        topicTitle: 'b2' as const,
        topicDescription: 'b3' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 791) return fontSizesByScreenSize[791]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
  }
}
